import { CountryLabelsForEn } from "../_constants/country-for-en";
import { CountryLabelsForJa } from "../_constants/country-for-ja";

/**
 * 言語に応じた国のラベル一覧を取得する
 * @param lang 言語
 * @returns 国のラベル
 */
export const getCountryLabels = (lang?: string) => {
  if (lang === "ja") {
    return CountryLabelsForJa;
  }
  return CountryLabelsForEn;
};
